import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { strings } from '/imports/strings';
import { useUser } from '/imports/hooks';
import { Icon } from '/imports/ui/Icon';

const NotPermittedPageStyled = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-align: center;
  .wrapper {
    margin: auto;
  }
  p {
    text-align: center;
    font-size: 1.1rem;
  }
`;

/** Page shown when the current user lacks permission; redirects to login if signed out. */
export const NotPermittedPage = () => {
  const user = useUser();
  const navigate = useNavigate();
  if (!user) navigate('/login');
  return (
    <NotPermittedPageStyled className="page">
      <div className="wrapper">
        <Icon icon="block" />
        <h2>{strings.YouAreNotPermitted()}</h2>
        <p><Link to="/">{strings.GoToHomePage()}</Link></p>
      </div>
    </NotPermittedPageStyled>
  );
};